export default __webpack_public_path__ + "fc642d1082b55c3f3953b2b6e9bb8c65.svg";